<template>
  <form class="ortic-form-horizontal" ref="form">
    <o-card v-if="item" :capExceed="item.cap_exceeded ? true : false" :title="$t('sandoz.pv_contract') + ' // ' + (item.contract_no ? item.contract_no : '-')">
      <b-tabs class="inline-tabs" ref="tabs" v-model="activeTab">
        <b-tab :title="$t('sandoz.general')" active>

          <b-row>
            <b-col>
              <o-value-select v-model="item.user_id" :label="$t('sandoz.owner')"
                              :readonly="readonly" text-field="name"
                              url="/api/system/users?filter%5Bactive%5D=1%25&sortBy=name&include=flm,approval_roles,regions&filter%5Brole%5D=Pharmavital%20Contract%20Management"
                              value-field="id" @input-object="setCurrentUser"></o-value-select>

              <o-form-group :label="$t('sandoz.customer_external_id')" class="mb-2">
                <b-input-group>
                  <input v-model="item.customer_external_id" class="form-control" disabled type="text">
                  <b-input-group-append v-if="!readonly">
                    <b-btn variant="primary" @click.prevent="setMasterAddress">
                      <fa icon="ellipsis-h"/>
                    </b-btn>
                  </b-input-group-append>
                </b-input-group>
              </o-form-group>

              <o-value-select v-model="item.contract_year" :items="years" :label="$t('sandoz.contract_year')"
                              :readonly="readonly" :title="$t('sandoz.contract_year')"/>
              <o-datepicker ref="contract_start" :typeable="true" :errorField="'contract_start'"
                            :label="$t('sandoz.contract_start')" v-model="item.contract_start" :disabled="readonly"/>
              <o-datepicker :typeable="true" :errorField="'contract_expiration'"
                            :label="$t('sandoz.contract_expiration')" v-model="item.contract_expiration"
                            :disabledDates="disableToDates" :disabled="readonly"/>
            
              <o-value-select :items="languages" :label="$t('sandoz.language')" v-model="item.language" :readonly="readonly || !!item.id"/>
            </b-col>
            <b-col>
              <template v-if="user.is_super_user">
                <o-textarea v-model="item.super_user_comment" :label="$t('sandoz.super_user_comment')"
                            :error-field="'super_user_comment'"
                            :class="isCommentError && !item.super_user_comment ? 'has-error' : ''"></o-textarea>
              </template>
            </b-col>
          </b-row>

          <b-btn @click.prevent="activeTab++">{{$t('sandoz.next')}}</b-btn>
        </b-tab>

        <b-tab :title="$t('sandoz.addresses')">
          <b-overlay :show="item.customer_external_id == null">

            <div class="d-flex">
            </div>

            <div class="table-responsive">
              <table class="table">
                <thead>
                <tr>
                  <th>{{ $t('sandoz.hco') }}</th>
                  <th>{{ $t('sandoz.address') }}</th>
                  <th>{{ $t('sandoz.zip') }}</th>
                  <th>{{ $t('sandoz.city') }}</th>
                  <th>{{ $t('sandoz.customer_external_id') }}</th>
                  <th>{{ $t('sandoz.classification') }}</th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(address, addressIndex) in item.addresses" :key="addressIndex"
                    :class="{'bg-light': address.address_type === 'master'}">
                  <td>
                    {{ address.company_name }}
                    <o-inline-edit v-if="address.address_type === 'master'" v-model="address.company_name"/>
                  </td>
                  <td>
                    {{ address.street }}
                    <o-inline-edit v-if="address.address_type === 'master'" v-model="address.street"/>
                  </td>
                  <td>
                    {{ address.zip }}
                    <o-inline-edit v-if="address.address_type === 'master'" v-model="address.zip"/>
                  </td>
                  <td>
                    {{ address.city }}
                    <o-inline-edit v-if="address.address_type === 'master'" v-model="address.city"/>
                  </td>
                  <td>{{ address.customer_external_id }}</td>
                  <td>
                    <b-form-select v-if="address.address_type !== 'master'" v-model="address.customer_size"
                      :options="heimCustomerSizes[addressIndex]" :class="{'border-danger': !address.customer_size}"
                      @change.native="addItemsToAddresses(false)"
                    ></b-form-select>
                  </td>
                  <td class="text-right text-nowrap">
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <template #overlay>
              <div class="text-center">
                <p>{{$t('sandoz.set_external_id_first')}}</p>
              </div>
            </template>
          </b-overlay>

          <b-btn @click.prevent="activeTab--">{{$t('sandoz.previous')}}</b-btn>
          <b-btn @click.prevent="activeTab++">{{$t('sandoz.next')}}</b-btn>
        </b-tab>
        <b-tab :title="$t('sandoz.items')">
          <contract-item :item="item" :active-tab="activeTab" :sortalysContract="sortalysContract" :user="user" :determErrorID="determErrorID" :months="months" :readonly="readonly" :fromDateErrorID="fromDateErrorID" ref="contractItem"
                         :pvContract="true" :reqBiosApoItems="reqBiosApoItems"></contract-item>
          <b-btn @click.prevent="activeTab--">{{$t('sandoz.previous')}}</b-btn>
          <b-btn @click.prevent="activeTab++">{{$t('sandoz.next')}}</b-btn>
        </b-tab>
        <b-tab :title="$t('sandoz.contract')">
          <o-button native-type="button" @click="confirmWithUser" class="btn btn-danger" target="_blank" :loading="pdfLoading" :disabled="pdfLoading">Download PDF</o-button>
          <template-download-button v-if="$route.params.id !== 'new'" :contract-id="$route.params.id" class="ml-2"/>
          <b-row class="mt-4">
            <b-col lg="12" md="12" xl="8">
              <template v-for="i in [1,2,3,4,5,6,7]">
                <o-form-group :key="i" :label="$t('sandoz.contract_partner_' + i)">
                  <b-container class="w-100 px-0">
                    <b-row>
                      <b-col class="pr-1">
                        <b-input-group :prepend="$t('sandoz.name')">
                          <b-form-input v-model="item['contract_partner_' + i]" :disabled="readonly"></b-form-input>
                        </b-input-group>
                      </b-col>
                      <b-col class="pl-1">
                        <b-input-group :prepend="$t('sandoz.title')">
                          <b-form-input v-model="item['contract_partner_' + i + '_title']" :disabled="readonly"></b-form-input>
                        </b-input-group>
                      </b-col>
                      <b-col class="pl-1">
                        <select class="custom-select title-dropdown" v-model="item['contract_partner_' + i + '_title_dropdown']" @change="setTitle(i)" :disabled="readonly">
                          <option v-for="titleItem in titleItems" :value="titleItem.value" :key="titleItem.value">{{titleItem.text}}</option>
                        </select>
                      </b-col>
                    </b-row>
                  </b-container>
                </o-form-group>
              </template>
            </b-col>
            <b-col lg="12" md="12" xl="4">
              <o-form-group>
                <b-form-checkbox v-model.lazy="item.vat" name="vat" value="x" :disabled="readonly">
                  {{ $t('sandoz.vat_obligation') }}
                </b-form-checkbox>
              </o-form-group>

              <o-input v-if="item.vat == 'x'" v-model="item.vat_number" :errorField="'vat_number'"
                       :label="$t('sandoz.vat_number')" :readonly="readonly"/>
              <o-input v-model="item.bank_name" :errorField="'bank_name'" :label="$t('sandoz.bank_name')" :readonly="readonly"/>
              <o-input v-model="item.bank_address" :errorField="'bank_address'" :label="$t('sandoz.bank_address')" :readonly="readonly"/>
              <o-input v-model="item.accountholder_name" :errorField="'accountholder_name'"
                       :label="$t('sandoz.accountholder_name')" :readonly="readonly"/>
              <o-input v-model="item.accountholder_address" :errorField="'accountholder_address'"
                       :label="$t('sandoz.accountholder_address')" :readonly="readonly"/>
              <o-input v-model="item.iban_no" :errorField="'iban_no'" :label="$t('sandoz.iban_no')" :readonly="readonly"/>

            </b-col>
          </b-row>
          <b-btn @click.prevent="activeTab--">{{$t('sandoz.previous')}}</b-btn>
          <b-btn @click.prevent="activeTab++">{{$t('sandoz.next')}}</b-btn>
        </b-tab>
        <b-tab :title="$t('sandoz.files')">
          <contract-file :item="item" :user="user"></contract-file>
          <b-btn @click.prevent="activeTab--">{{$t('sandoz.previous')}}</b-btn>
        </b-tab>
      </b-tabs>
      <address-search ref="addressSearch" :address-mode-checkbox="showAddressModeCheckbox" contract-type="pv" @address-selected="addressSelected"></address-search>
    </o-card>
    <o-action-toolbar>
      <div class="d-flex w-100">
        <o-button type="button" variant="outline-primary" @click.prevent="back">{{ $t('core.back') }}</o-button>
        <div class="ml-auto">
          <o-button v-if="(user && user.is_super_user) && (item && (item.status == 'Committed' || item.status == 'Approved' || item.status == 'Signed') && item.contract_year > 2023)"
                    :loading="saving" type="button" variant="primary"
                    @click.prevent="$refs.resetContractModel.show()">{{ $t('sandoz.reset_to_draft') }}
          </o-button>
          <template v-if="!$route.path.split('/').includes('view')">
            <template v-if="saveDisabled">
              <o-button v-if="(item && (item.status == 'Draft' || item.status == 'Feedback'))" :loading="saving" type="button" variant="danger">{{ $t('sandoz.budget_used_up') }}
              </o-button>
            </template>
            <template v-else>
              <o-button v-if="(item && (item.status == 'Draft' || item.status == 'Feedback'))" :loading="saving" type="button" variant="primary"
                      @click.prevent="contractCanApprovable">{{ $t('sandoz.approve') }}
              </o-button>
              <o-button v-if="(item && (item.status == 'Draft'))" :loading="saving" type="button" variant="primary"
                        @click.prevent="save">{{ $t('sandoz.save_draft') }}
              </o-button>
              <o-button v-if="(item && (item.status == 'Feedback'))" :loading="saving" type="button" variant="primary"
                        @click.prevent="save">{{ $t('core.save') }}
              </o-button>
            </template>
          </template>
        </div>
      </div>
    </o-action-toolbar>
    <b-modal id="modal-previous-contract" ref="addPreviousContractModel" :title="$t('sandoz.select_previous_contract')"
                     :ok-only="true" size="xl" :ok-title="$t('core.cancel')">
        <o-table url="/api/sandoz/contracts?include=master_address_single" title="" ref="previousContractList" :enable-new="false"
                  :enable-delete="false" :enable-edit="false" :shadow="false" :only-filterable="true">
            <template slot="filter">
                <o-filter v-on:filter-updated="(filters) => $refs.previousContractList.setFilters(filters)">
                    <o-filter-text :title="$t('sandoz.contract_no')" column="contract_no"></o-filter-text>
                    <o-filter-text :title="$t('sandoz.customer_external_id')" column="customer_external_id"></o-filter-text>
                    <o-filter-select :items="years" :title="$t('sandoz.contract_year')" column="contract_year"></o-filter-select>
                </o-filter>
            </template>
            <template slot="head">
                <o-table-header column="contract_no">{{$t('sandoz.contract_no')}}</o-table-header>
                <o-table-header column="customer_external_id">{{$t('sandoz.customer_external_id')}}</o-table-header>
                <o-table-header column="contract_year">{{$t('sandoz.contract_year')}}</o-table-header>
                <o-table-header :sortable="false">{{$t('sandoz.name')}}</o-table-header>
                <o-table-header :sortable="false">{{$t('sandoz.last_name')}}</o-table-header>
                <o-table-header :sortable="false">{{$t('sandoz.company_name')}}</o-table-header>
                <o-table-header :sortable="false">{{$t('sandoz.street')}}</o-table-header>
                <o-table-header :sortable="false">{{$t('sandoz.zip')}}</o-table-header>
                <o-table-header :sortable="false">{{$t('sandoz.city')}}</o-table-header>
            </template>
            <template slot="body" slot-scope="previousContractProps">
                <td>{{ previousContractProps.item.contract_no }}</td>
                <td>{{ previousContractProps.item.customer_external_id }}</td>
                <td>{{ previousContractProps.item.contract_year }}</td>
                <td>{{ previousContractProps.item.master_address_single && previousContractProps.item.master_address_single.data ?
                    previousContractProps.item.master_address_single.data.name : ''}}
                </td>
                <td>{{ previousContractProps.item.master_address_single && previousContractProps.item.master_address_single.data ?
                    previousContractProps.item.master_address_single.data.last_name : ''}}
                </td>
                <td>{{ previousContractProps.item.master_address_single && previousContractProps.item.master_address_single.data ?
                    previousContractProps.item.master_address_single.data.company_name : ''}}
                </td>
                <td>{{ previousContractProps.item.master_address_single && previousContractProps.item.master_address_single.data ?
                    previousContractProps.item.master_address_single.data.street : ''}}
                </td>
                <td>{{ previousContractProps.item.master_address_single && previousContractProps.item.master_address_single.data ?
                    previousContractProps.item.master_address_single.data.zip : ''}}
                </td>
                <td>{{ previousContractProps.item.master_address_single && previousContractProps.item.master_address_single.data ?
                    previousContractProps.item.master_address_single.data.city : ''}}
                </td>
            </template>
            <template slot="body-controls" slot-scope="previousContractProps">
                <td class="text-right">
                    <div v-if="previousContractProps.item.id === item.id">
                        <span class="badge badge-success">Current </span>
                    </div>
                    <div v-else-if="previousContractProps.item.id === item.previous_contract">
                        <span class="badge badge-warning">Previous</span>
                    </div>
                    <div v-else class="btn-group btn-group-sm" role="group" aria-label="edit controls">
                        <b-btn variant="primary" @click="addPreviousContract(previousContractProps.item)">
                            <fa icon="arrow-right"/>
                        </b-btn>
                    </div>
                </td>
            </template>
        </o-table>
    </b-modal>
    <b-modal id="modal-reset-contract" ref="resetContractModel" :title="$t('sandoz.reset_to_draft')">
      {{$t('sandoz.reset_confirmation')}}
      <template #modal-footer="{ ok, cancel, hide }">
        <b-button variant="secondary" @click="cancel()">
          {{$t('core.cancel')}}
        </b-button>
        <b-button variant="primary" @click="resetToDraft()">
          {{$t('core.ok')}}
        </b-button>
      </template>
    </b-modal>
    <b-modal id="modal-duplicate-contract" ref="duplicateContractModel" :title="$t('sandoz.duplicate_contract')">
      {{$t('sandoz.duplicate_contract_error')}}
      <template #modal-footer="{ ok, cancel, hide }">
        <b-button variant="secondary" @click="showDuplicateContract">
          {{$t('sandoz.show_contract')}}
        </b-button>
        <b-button variant="primary" @click="cancel()">
          {{$t('core.ok')}}
        </b-button>
      </template>
    </b-modal>
    <b-modal id="modal-past-contract" ref="pastContractModel" :title="$t('sandoz.past_contract')">
      {{$t('sandoz.past_contract_warning')}}
      <template #modal-footer="{ ok, cancel, hide }">
        <b-button variant="secondary" @click="cancel()">
          {{$t('core.cancel')}}
        </b-button>
        <b-button variant="primary" @click="saveAndStartApproval()">
          {{ $t('sandoz.approve') }}
        </b-button>
      </template>
    </b-modal>
  </form>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import { contractYears } from '../../../utils/contractYear'
import AddressSearch from '../partials/AddressSearch.vue'
import OValueSelectControl from '../../../components/OrticValueSelectControl.vue'
import moment from 'moment'
import {diff} from '~/functions/object.js'
import _ from 'lodash';
import Vue from "vue";
import ContractFile from '../partials/ContractFiles.vue'
import ContractItem from '../partials/ContractItem.vue'
import TemplateDownloadButton from '../partials/TemplateDownloadButton.vue'

export default {
  components: {
    OValueSelectControl,
    AddressSearch,
    contractYears,
    ContractFile,
    ContractItem,
    TemplateDownloadButton
  },
  data: () => ({
    years: [],
    item: null,
    customerSizes: [],
    watchers: [],
    saving: false,
    addressIndex: null,
    toggleItems: false,
    listItem: [],
    selectedItems: [],
    searchItem: null,
    months: [],
    loaded: false,
    currentUser: null,
    watcherWorking: false,
    addItemsToAllAddress: false,
    showAddressModeCheckbox: false,
    changeExternalID: false,
    downloadPDF: false,
    itemOld: null,
    languages: [],
    accordionItems: [],
    showContract: null,
    copyMasterProductToChild: [],
    determErrorID: [],
    addItemsToAddressFlag: false,
    addItemsToAddressFlagIndex: null,
    titleItems: [],
    disableToDates : {
      to: null
    },
    activeTab: 0,
    heimCustomerSizes: [],
    pdfLoading: false,
    vendorFormLinks: {
      DE: 'https://sandozcollab.sharepoint.com/:w:/r/sites/sandoz-schweiz-intranet/teamsites/Freigegebene%20Dokumente/Marketing/ZZ_NICHT%20LOESCHEN%20ODER%20VERSCHIEBEN/Formular%20f%C3%BCr%20Vendorer%C3%B6ffnung_DE_2024.doc?d=w429524bc2ddd45dcaa24f693c1aaae5b&csf=1&web=1&e=508gVl&xsdata=MDV8MDJ8YmVhdC5zdGVpbmVnZ2VyQHNhbmRvei5jb218NzA0NDBhMWNlMjJkNGRjMmQ5ZDcwOGRlMTFmZjRhN2V8MTVlYWUyY2IxYzk0NGQxZjgwNGZjYjBjMzQ3ZGJkYWR8MHwwfDYzODk2Nzk4NTQ4NTg1NDkxMXxVbmtub3dufFRXRnBiR1pzYjNkOGV5SkZiWEIwZVUxaGNHa2lPblJ5ZFdVc0lsWWlPaUl3TGpBdU1EQXdNQ0lzSWxBaU9pSlhhVzR6TWlJc0lrRk9Jam9pVFdGcGJDSXNJbGRVSWpveWZRPT18MHx8fA%3d%3d&sdata=ZWloUzZNUGk4NWgrRzRvKzFsQmhIeWI3T01rTGpTU1V3M3pEYWI5dGRNQT0%3d',
      FR: 'https://sandozcollab.sharepoint.com/:w:/r/sites/sandoz-schweiz-intranet/teamsites/Freigegebene%20Dokumente/Marketing/ZZ_NICHT%20LOESCHEN%20ODER%20VERSCHIEBEN/Formular%20f%C3%BCr%20Vendorer%C3%B6ffnung_FR_2024.doc?d=w49f246b7c89848be897188826334fc2b&csf=1&web=1&e=pID1ir&xsdata=MDV8MDJ8YmVhdC5zdGVpbmVnZ2VyQHNhbmRvei5jb218NzA0NDBhMWNlMjJkNGRjMmQ5ZDcwOGRlMTFmZjRhN2V8MTVlYWUyY2IxYzk0NGQxZjgwNGZjYjBjMzQ3ZGJkYWR8MHwwfDYzODk2Nzk4NTQ4NTgwMDY5MHxVbmtub3dufFRXRnBiR1pzYjNkOGV5SkZiWEIwZVUxaGNHa2lPblJ5ZFdVc0lsWWlPaUl3TGpBdU1EQXdNQ0lzSWxBaU9pSlhhVzR6TWlJc0lrRk9Jam9pVFdGcGJDSXNJbGRVSWpveWZRPT18MHx8fA%3d%3d&sdata=TFNEOTgyN25YM3ppR2xlVXRxRGpFR0dna3F2YURkV0JRYW9uaktaZFNPND0%3d',
      IT: 'https://sandozcollab.sharepoint.com/:w:/r/sites/sandoz-schweiz-intranet/teamsites/Freigegebene%20Dokumente/Marketing/ZZ_NICHT%20LOESCHEN%20ODER%20VERSCHIEBEN/Formular%20f%C3%BCr%20Vendorer%C3%B6ffnung_IT_2024.doc?d=w6a072b20b8504e1c9ff128710757020e&csf=1&web=1&e=umGkd2&xsdata=MDV8MDJ8YmVhdC5zdGVpbmVnZ2VyQHNhbmRvei5jb218NzA0NDBhMWNlMjJkNGRjMmQ5ZDcwOGRlMTFmZjRhN2V8MTVlYWUyY2IxYzk0NGQxZjgwNGZjYjBjMzQ3ZGJkYWR8MHwwfDYzODk2Nzk4NTQ4NTgzMTc0MnxVbmtub3dufFRXRnBiR1pzYjNkOGV5SkZiWEIwZVUxaGNHa2lPblJ5ZFdVc0lsWWlPaUl3TGpBdU1EQXdNQ0lzSWxBaU9pSlhhVzR6TWlJc0lrRk9Jam9pVFdGcGJDSXNJbGRVSWpveWZRPT18MHx8fA%3d%3d&sdata=b3pRT1dTRXlXcjkwaE5Lbm1tNjFTU0g4SERKd2ZwUzh3bU9RcjhrOGUwWT0%3d'
    },
    fromDateErrorID: [],
    isCommentError: false,
    saveDisabled: false,
    pictures: [],
    reqBiosApoItems: [],
  }),
  mounted () {
    this.loadData()
  },
  computed: {
    ...mapGetters({
      user: 'auth/user'
    }),
    readonly () {
      return this.item && this.item.status != 'Draft' && this.item.status != 'Feedback'
    },
    sortalysContract() {
      return this.item.type === 'SD_SORTALYS' || this.item.type === 'CNS_SORTALYS' || this.item.type === 'ONCO_SORTALYS' || this.item.type === 'IMMUNO_SORTALYS'
    },
    draftInvoiceAvailable () {
      return this.item.id !== undefined && this.item.contract_year ? moment((this.item.contract_year - 1) + '-12-01').isSameOrBefore(moment().format('YYYY-MM-DD')) : false
    }
  },
  watch: {
    'item.contract_start': function (newVal) {
      let startDate = moment(newVal);
      //const marchEndDate = moment(startDate.format('YYYY') + "-03-31")
      // if(startDate < marchEndDate) {
      //   this.item.contract_start = moment().year() + '-01-01'
      // }
      this.disableToDates.to = new Date(startDate.format('YYYY'), startDate.month(), startDate.format('D'))
      this.setContractDateToItems(newVal)

    },
    'item.contract_expiration': function (newVal) {
      this.setContractDateToItems(newVal)
    },
    saving: function (newVal, oldVal) {
      const self = this
      if (!newVal) {
        setTimeout(function (){
          self.pdfLoading = newVal
        }, 1000)
      } else {
        self.pdfLoading = newVal
      }
    }
  },
  created () {
    this.years = contractYears().filter(year => {
      return year.value > 2024
    })

    this.months = [
      { value: '01', text: this.$i18n.t('core.january_short') },
      { value: '02', text: this.$i18n.t('core.february_short') },
      { value: '03', text: this.$i18n.t('core.march_short') },
      { value: '04', text: this.$i18n.t('core.april_short') },
      { value: '05', text: this.$i18n.t('core.may_short') },
      { value: '06', text: this.$i18n.t('core.june_short') },
      { value: '07', text: this.$i18n.t('core.july_short') },
      { value: '08', text: this.$i18n.t('core.august_short') },
      { value: '09', text: this.$i18n.t('core.september_short') },
      { value: '10', text: this.$i18n.t('core.october_short') },
      { value: '11', text: this.$i18n.t('core.november_short') },
      { value: '12', text: this.$i18n.t('core.december_short') }
    ]

    this.languages = [
      {value: 'DE', text: 'DE'},
      {value: 'FR', text: 'FR'},
      {value: 'IT', text: 'IT'}
    ]


  },
  methods: {
    loadData () {
      this.saving = true
      var url = `/api/sandoz/pv/contracts/${this.$route.params.id}?include=word_files.user,pdfs.user`
      this.url = url
      axios
        .get(url)
        .then((response) => {
          var item = response
          if (this.dataKey) {
            item = response[this.dataKey]
          }
          this.item = item.data

          // set default user
          if (!this.item.user_id) {
            this.item.user_id = this.user.id
          }

          this.setTitleItems()

          this.item.type = 'PV'

          var partners = [1,2,3,4,5,6,7];
          for(var i=1; i<=partners.length; i++) {
            this.item['contract_partner_' + i + '_title_dropdown'] = null
          }
          this.getAddressItemData()

          if(this.item.contract_year < 2025) {
            this.item.contract_year = 2025
            this.setContractNo()
            this.addItemsToAddresses()
            this.changeContractDuration()
          }
        })
    },
    getAddressItemData () {
      var url = `/api/sandoz/pv/contracts/detail/${this.$route.params.id}`
      axios
        .get(url)
        .then((response) => {
          var item = response
          this.item.addresses = item.data.addresses
          var dbItem = Object.assign({}, this.item)
          this.$nextTick(() => {
            this.loaded = true
            this.addItemsToAddresses(false)
            this.setDefaultPrice()
            this.setContractDateToItems()
            this.$refs.contractItem.setQuantityChildParent(1)
            this.$refs.contractItem.setQuantityToChildSpecialLoad()
            this.enableWatchers()
            this.$refs.contractItem.setSelectedItemPrice()
            this.$nextTick(() => {
              this.itemOld = {...this.item}
              this.itemOld.marketing_activities = Math.round(dbItem.marketing_activities)
              this.saving = false
              this.$refs.contractItem.$forceUpdate()
            })
          })
        })
    },
    setBuyingGroupLabel () {
      if (['SD', 'CNS', 'ONCO', 'IMMUNO'].includes(this.item.type)) {
        this.buyingGroupLabel = 'customer_group'
      } else {
        this.buyingGroupLabel = 'buying_group'
      }
    },
    enableWatchers () {
      this.watchers.push(this.$watch('item.type', (newVal) => {
        this.setBuyingGroupLabel()
        this.setContractNo()
      }))
      this.watchers.push(this.$watch('item.customer_external_id', (newVal) => {
        this.changeExternalID = true
        this.setContractNo()
      }))
      this.watchers.push(this.$watch('item.contract_year', (newVal) => {
        this.setContractNo()
        this.addItemsToAddresses()
        this.changeContractDuration()
      }))

      this.watchers.push(this.$watch('item.language', (newVal) => {
        this.addItemsToAddresses()
        this.setTitleItems()
      }))
    },
    disableWatchers () {

    },
    contractCanApprovable() {
      if(this.item.contract_start && moment().isAfter(this.item.contract_start)) {
        if(this.user.is_super_user) {
          this.$refs.pastContractModel.show()
          return
        } else {
          if(this.checkFromDate()) {
            this.activeTab = 2
            this.$notify({
              title: this.$i18n.t('core.save_error'),
              text: this.$i18n.t('sandoz.from_date_error'),
              type: 'error'
            })
            return
          }
        }
      }

      this.saveAndStartApproval()
    },
    saveAndStartApproval () {
      if(this.item.contract_start && moment().isAfter(this.item.contract_start)) {
        if (this.user.is_super_user && !this.item.super_user_comment) {
          this.activeTab = 0
          this.isCommentError = true
          this.$notify({
            title: this.$i18n.t('core.save_error'),
            text: this.$i18n.t('sandoz.super_user_comment_error'),
            type: 'error'
          })
          return
        }
      }

      // check bank information mandatory
      if (this.item.sales_line && this.item.sales_line.bank_information_mandatory === true) {

        const validations = [
          { field: 'bank_name', message: this.$i18n.t('sandoz.bank_name_required') },
          { field: 'bank_address', message: this.$i18n.t('sandoz.bank_address_required') },
          { field: 'accountholder_name', message: this.$i18n.t('sandoz.account_holder_name_required') },
          { field: 'accountholder_address', message: this.$i18n.t('sandoz.account_holder_address_required') },
          { field: 'iban_no', message: this.$i18n.t('sandoz.iban_no_required') },
        ]

        for (let v of validations) {
          const value = this.item[v.field]

          if (!value || value.trim() === '' || value.trim() === null) {
            this.$notify({
              title: this.$i18n.t('core.validation_error'),
              text: this.$i18n.t('core.validation_error_text', { message: v.message }),
              type: 'error'
            })
            return
          }
        }
      }

      this.item.status = 'Approved'
      this.save()
    },
    checkFromDate() {
      const self = this
      if(self.item.addresses) {
        const now = new Date()
        let fromDateError = false

        let currentMonth = now.getMonth() + 1
        currentMonth = (currentMonth < 10 ? '0' + currentMonth : currentMonth).toString()
        let currentYear = now.getFullYear().toString()

        self.fromDateErrorID = []
        self.item.addresses.forEach(function (address) {
          if(address.address_type === 'delivery') {
            address.items.forEach(function (line) {
              if(line.type === 'marketing_activity' &&
                  ((line.valid_from_year === currentYear && line.valid_from_month <= currentMonth) || line.valid_from_year < currentYear) &&
                  (line.exist_value === null && (line.contract_line_exist_attribute === 'indeterminate' || !line.contract_line_exist_attribute)) &&
                  (line.delivery && line.delivery['yearly'].quantity !== null || line.delivery['q1'].quantity !== null || line.delivery['q2'].quantity !== null || line.delivery['q3'].quantity !== null || line.delivery['q4'].quantity !== null)
              ) {
                self.fromDateErrorID.push(address.id+'-'+line.product.id)
                fromDateError = true
              }

              if(line.children && Object.keys(line.children).length) {
                line.children.forEach(function (subLine) {

                  if(subLine.type === 'marketing_activity' &&
                      ((subLine.valid_from_year === currentYear && subLine.valid_from_month <= currentMonth) || subLine.valid_from_year < currentYear) &&
                      (subLine.exist_value === null && (subLine.contract_line_exist_attribute === 'indeterminate' || !subLine.contract_line_exist_attribute)) &&
                      (subLine.delivery && subLine.delivery['yearly'].quantity !== null || subLine.delivery['q1'].quantity !== null || subLine.delivery['q2'].quantity !== null || subLine.delivery['q3'].quantity !== null || subLine.delivery['q4'].quantity !== null)
                  ) {
                    self.fromDateErrorID.push(address.id+'-'+subLine.product.id)
                    fromDateError = true
                  }

                  if(subLine.children && Object.keys(subLine.children).length) {
                    subLine.children.forEach(function (childLine) {
                      if(childLine.type === 'marketing_activity' &&
                          ((childLine.valid_from_year === currentYear && childLine.valid_from_month <= currentMonth) || childLine.valid_from_year < currentYear) &&
                          (childLine.exist_value === null && (childLine.contract_line_exist_attribute === 'indeterminate' || !childLine.contract_line_exist_attribute)) &&
                          (childLine.delivery && childLine.delivery['yearly'].quantity !== null || childLine.delivery['q1'].quantity !== null || childLine.delivery['q2'].quantity !== null || childLine.delivery['q3'].quantity !== null || childLine.delivery['q4'].quantity !== null)
                      ) {
                        self.fromDateErrorID.push(address.id+'-'+childLine.product.id)
                        fromDateError = true
                      }
                    })
                  }
                })
              }
            })
          }
        })
        return fromDateError
      }
    },
    resetToDraft () {
      this.item.status = 'Draft'

      this.item.approval_date_1 = null
      this.item.approval_person_1 = null

      this.item.approval_date_2 = null
      this.item.approval_person_2 = null

      this.item.approval_date_3 = null
      this.item.approval_person_3 = null

      this.item.approval_date_4 = null
      this.item.approval_person_4 = null

      this.item.approval_date_5 = null
      this.item.approval_person_5 = null

      this.item.approval_date_6 = null
      this.item.approval_person_6 = null

      this.item.next_approver = null

      if(this.item.status === 'Signed') {
        this.item.contract_version = (!this.item.contract_version || this.item.contract_version == 1) ? 2 : this.item.contract_version + 1
      }
      this.save()
      this.$refs.resetContractModel.hide()
    },
    save () {
      var url = `/api/sandoz/pv/contracts/${this.$route.params.id}?include=word_files.user`
      // var url = this.url
      var route = this.$route

      // this happens if we create a new data record and update it right away without navigating way. We'll still have
      // new in our url, but we don't want to create a new record, we want to update the record we just created.
      // @TODO we should do this in a more elegant way that doesn't require search & replace
      if (url.indexOf('/new') > 0 && 'id' in this.item) {
        url = url.replace('/new', '/' + this.item.id)
      }

      var root = this.$root
      var self = this

      if(self.item.customer_external_id ===  null) {
        self.$notify({
          title: self.$i18n.t('core.validation_error'),
          text: self.$i18n.t('core.validation_error_text', { message: self.$i18n.t('sandoz.external_id_required') }),
          type: 'error'
        })
        return
      }

      if(self.item.contract_year ===  null) {
        self.$notify({
          title: self.$i18n.t('core.validation_error'),
          text: self.$i18n.t('core.validation_error_text', { message: self.$i18n.t('sandoz.contract_year_required') }),
          type: 'error'
        })
        return
      }

      if(!self.sortalysContract) {
        var indeterminantEror = self.checkIndeterminantCheckbox();
        if(indeterminantEror) {
          self.$notify({
            title: self.$i18n.t('core.validation_error'),
            text: self.$i18n.t('core.validation_error_text', { message: self.$i18n.t('sandoz.indeterminat_error') }),
            type: 'error'
          })
          return
        }
      }

      this.disableWatchers()
      if (this.$refs.pastContractModel && this.$refs.pastContractModel.isVisible) {
        this.$refs.pastContractModel.hide()
      }
      this.saving = true
      this.showContract = null

      axios
        .post(url, this.item)
        .then((response) => {
          let savedItem = response.data
          // this.item = response.data

          // assign our new id to the route params in case someone wants to work with it
          if ('id' in response.data) {
            route.params.id = response.data.id
          }

          this.$notify({
            title: this.$i18n.t('core.saved'),
            text: this.$i18n.t('core.saved_text')
          })

          // remove all error states
          var elements = document.querySelectorAll('.has-error')
          elements.forEach((element) => {
            element.classList.remove('has-error')
          })
          this.fromDateErrorID = []
          this.isCommentError = false

          this.showDeletedFiles = false
          this.showDeletedPDFFiles = false

          // clear all errors
          root.errors = {}
          if(this.downloadPDF) {
            this.pdfContract()
            this.$nextTick(function (){
              this.itemOld = {...this.item}
              this.downloadPDF = false
            })
          } else {
            this.loaded = true
            this.getAddressItemData()
          }
        })
        .catch((error) => {
          // stop loading indicator
          self.saving = false

          if (error.response.status === 422 && 'data' in error.response && 'message' in error.response.data) {
            this.$notify({
              title: this.$i18n.t('core.validation_error'),
              text: this.$i18n.t('core.validation_error_text', { message: error.response.data.message }),
              type: 'error'
            })
            if ('data' in error.response && 'errors' in error.response.data) {
              root.errors = error.response.data.errors
            }
          } else {
            if(error.response.data && 'contract_error' in error.response.data && error.response.data.contract_error === 'contract_already_exists') {
              this.showContract = error.response.data.contract
              this.$refs.duplicateContractModel.show()
            } else {
              this.$notify({
                title: this.$i18n.t('core.save_error'),
                text: this.$i18n.t('core.save_error_text', { url: this.url }),
                type: 'error'
              })
            }
          }
        })
    },
    back () {
      this.$router.back()
    },
    addAddress () {
      this.addressMode = 'delivery'
      this.showAddressModeCheckbox = false
      this.$refs.addressSearch.showAddressSearchModal(this)
    },
    setContractNo () {
      if (!this.item.type || !this.item.customer_external_id) {
        return
      }
      this.item.contract_no = `${this.item.type}-${this.item.contract_year - 2000}-${this.item.customer_external_id}`
    },
    setCurrentUser(user) {
      if (!user) {
        return
      }
      this.currentUser = user

      if (user.flm && user.flm.data && user.flm.data.flm_role) {
        this.item.flm_role = user.flm.data.flm_role
        if(this.itemOld) {
          this.itemOld.flm_role = user.flm.data.flm_role
        }
      }
    },
    setApprover(num, val) {
      if (this.item['approver_' + num] != val) {
        this.item['approver_' + num] = val

        // clear existing
        for (let i = num; i < 6; i++) {
          this.item['approval_date_' + i] = null
          this.item['approval_person_' + i] = null
        }

        // reset next approver if needed
        this.item.next_approver = Math.min(this.item.next_approver, num)
      }
    },
    clearApprover(i) {
      this.item['approval_date_' + i] = null
      this.item['approval_person_' + i] = null
    },
    clearApproverRole(i) {
      this.item['approver_' + i] = null
    },
    setMasterAddress () {
      this.addressMode = 'master'
      // only SD and sortalys contracts can have multiple contracts for a single practice
      this.showAddressModeCheckbox = this.item.type == 'SD' || this.sortalysContract
      this.$refs.addressSearch.showAddressSearchModal(this)
    },
    setWithoutWatcher(propertyName, value) {
      if (this.watcherWorking || !this.loaded) {
        return
      }
      this.watcherWorking = true
      this.item[propertyName] = value
      this.$nextTick(() => {
        this.watcherWorking = false
      })
    },
    addressSelected (addressEvent) {
      let address = addressEvent.address
      let multipleContractsPerPractice = addressEvent.multipleContractsPerPractice
      let owningComponent = addressEvent.owningComponent
      let owningComponentData = owningComponent.$data

      // set external id
      let externalId = multipleContractsPerPractice ? address.external_id : address.org_external_id

      switch (this.addressMode) {
        case 'master':
          owningComponentData.item.customer_external_id = externalId

          // set bank data
          // owningComponentData.item.vat = !!address.org_vat ? 'x': null
          owningComponentData.item.vat_number = address.org_vat
          owningComponentData.item.bank_name = address.org_bank_name
          owningComponentData.item.bank_address = address.org_bank_address
          owningComponentData.item.accountholder_name = address.org_bank_account
          owningComponentData.item.accountholder_address = address.org_bank_account_address
          owningComponentData.item.iban_no = address.org_iban

          this.item.language = address.language
          // set buying group
          if(address.buying_group && Object.keys(address.buying_group).length > 0){
            this.item.buying_group_code_when_uploaded = address.buying_group.buying_group_code
          } else {
            this.item.buying_group_code_when_uploaded = null
          }

          let masterAddressData = {
            del_address: 1,
            address_type: 'master',
            company_name: address.org_full_name,
            street: address.org_street,
            zip: address.org_zip_code,
            city: address.org_city,
            customer_external_id: externalId,
            customer_external_id_hcp: address.external_id,
            customer_size: address.org_pharmacy_classification,
            default_customer_size: address.org_pharmacy_classification
          }

          let firstAddress = owningComponentData.item.addresses.length == 0

          if (owningComponentData.item.addresses.length > 0) {
            owningComponentData.item.addresses[0] = masterAddressData
          } else {
            owningComponentData.item.addresses.push(masterAddressData)
          }

          // always add a delivery address as well
          let deliveryAddress = {
            del_address: owningComponentData.item.addresses.length + 1,
            address_type: 'delivery',
            company_name: address.org_full_name,
            street: address.org_street,
            zip: address.org_zip_code,
            city: address.org_city,
            customer_external_id: externalId,
            customer_external_id_hcp: address.external_id,
            customer_size: address.org_pharmacy_classification,
            default_customer_size: address.org_pharmacy_classification,
            items: []
          }
          if (firstAddress) {
            owningComponentData.item.addresses.push(deliveryAddress)
            this.addItemsToAddresses(false)
          }

          break
        case 'delivery':
          owningComponentData.item.addresses.push({
            del_address: owningComponentData.item.addresses.length + 1,
            address_type: 'delivery',
            company_name: address.org_full_name,
            street: address.org_street,
            zip: address.org_zip_code,
            city: address.org_city,
            customer_external_id: externalId,
            customer_external_id_hcp: address.external_id,
            customer_size: address.org_pharmacy_classification,
            default_customer_size: address.org_pharmacy_classification,
            items: []
          })
          this.addItemsToAddresses(false)
          this.setContractDateToItems()
          break
      }
    },
    setCustomerSize (address, index) {
      /*if(address.default_customer_size === 'Klein') {
        this.customerSizes[index] = [
          { value: '', text: '' },
          { value: 'Klein', text: this.$i18n.t('sandoz.small') }
        ]

        this.heimCustomerSizes[index] = [
          { value: '', text: '' }
        ]
      } else if(address.default_customer_size === 'Mittel') {
        this.customerSizes[index] = [
          { value: '', text: '' },
          { value: 'Mittel', text: this.$i18n.t('sandoz.medium') }
        ]

        this.heimCustomerSizes[index] = [
          { value: '', text: '' },
          { value: 'Klein', text: this.$i18n.t('sandoz.small') },
          { value: 'Mittel', text: this.$i18n.t('sandoz.medium') }
        ]
      } else if(address.default_customer_size === 'Gross') {
        this.customerSizes[index] = [
          { value: '', text: '' },
          { value: 'Mittel', text: this.$i18n.t('sandoz.medium') },
          { value: 'Gross', text: this.$i18n.t('sandoz.big') }
        ]

        this.heimCustomerSizes[index] = [
          { value: '', text: '' },
          { value: 'Klein', text: this.$i18n.t('sandoz.small') },
          { value: 'Mittel', text: this.$i18n.t('sandoz.medium') },
          { value: 'Gross', text: this.$i18n.t('sandoz.big') }
        ]
      } else { */
        this.customerSizes[index] = [
          { value: '', text: '' },
          { value: 'Mittel', text: this.$i18n.t('sandoz.medium') },
          { value: 'Gross', text: this.$i18n.t('sandoz.big') },
          { value: 'Sehr gross', text: this.$i18n.t('sandoz.very_big') }
        ]

        this.heimCustomerSizes[index] = [
          { value: '', text: '' },
          { value: 'Klein', text: this.$i18n.t('sandoz.small') },
          { value: 'Mittel', text: this.$i18n.t('sandoz.medium') },
          { value: 'Gross', text: this.$i18n.t('sandoz.big') },
          { value: 'Sehr gross', text: this.$i18n.t('sandoz.very_big') }
        ]
      // }
    },
    setDefaultPrice() {
      var _self = this
      _self.$nextTick(function (){
        if(_self.item.addresses) {
          _self.item.addresses.forEach(function (address) {
            if(address.address_type !== 'delivery') {
              return false
            }

            if(address.items.length) {
              address.items.forEach(function (item) {
                item.price = item.loaded_price ? Math.round(item.loaded_price): null
                if (item.children && Object.keys(item.children).length) {
                  item.children.forEach(function (subItem){
                    subItem.price = subItem.loaded_price ? Math.round(subItem.loaded_price): null

                    if (subItem.children && Object.keys(subItem.children).length) {
                      subItem.children.forEach(function (childItem) {
                        childItem.price = childItem.loaded_price ? Math.round(childItem.loaded_price): null
                      })
                    }
                  })
                }
              })
            }
          })
        }
      })
    },
    setContractDateToItems() {
      const self = this
      const startDate = moment(self.item.contract_start)
      const expiredDate = moment(self.item.contract_expiration)

      let date = null
      let startMonth = null
      let startYear = null
      let endDate = null
      let endMonth = null
      let endYear = null
      if (startDate.isValid()) {
        date = startDate.date()
        startMonth = startDate.month() + 1
        startYear = startDate.year()
      }

      if (expiredDate.isValid()) {
        endDate = expiredDate.date()
        endMonth = expiredDate.month() + 1
        endYear = expiredDate.year()
      }

      startMonth = (startMonth < 10 ? '0' + startMonth : startMonth).toLocaleString()
      endMonth = (endMonth < 10 ? '0' + endMonth : endMonth).toLocaleString()

      if(self.item.addresses) {
        self.item.addresses.forEach(function (address, index) {
          if(address.address_type !== 'delivery') {
            return false
          }

          if(address.items) {
            address.items.forEach(function (line) {
              if(line.children) {
                line.children.forEach(function (subLine) {
                  if(subLine.children) {
                    subLine.children.forEach(function (childLine) {
                      childLine.valid_from_month = startYear != childLine.valid_from_year ? 1 : (childLine.valid_from_month ? (childLine.valid_from_changed ? childLine.valid_from_month : (childLine.id && !childLine.valid_from_changed ? childLine.valid_from_month: startMonth)) : startMonth)
                      childLine.valid_from_year = startYear != childLine.valid_from_year ? startYear : childLine.valid_from_year

                      childLine.valid_to_month = endYear != childLine.valid_to_year ? 12 : (childLine.valid_to_month ? (childLine.valid_to_changed ? childLine.valid_to_month : (childLine.id && !childLine.valid_to_changed ? childLine.valid_to_month: endMonth)) : endMonth)
                      childLine.valid_to_year = endYear != childLine.valid_to_year ? startYear : childLine.valid_to_year

                      self.$nextTick(function () {
                        self.$refs.contractItem.setPrice(childLine, index)
                        self.$refs.contractItem.setHighLighter(childLine)
                      })
                    })
                  }

                  subLine.valid_from_month = startYear != subLine.valid_from_year ? 1 : (subLine.valid_from_month ? (subLine.valid_from_changed ? subLine.valid_from_month : (subLine.id && !subLine.valid_from_changed ? subLine.valid_from_month: startMonth)) : startMonth)
                  subLine.valid_from_year = startYear != subLine.valid_from_year ? startYear : subLine.valid_from_year

                  subLine.valid_to_month = endYear != subLine.valid_to_year ? 12 : (subLine.valid_to_month ? (subLine.valid_to_changed ? subLine.valid_to_month : (subLine.id && !subLine.valid_to_changed ? subLine.valid_to_month: endMonth)) : endMonth)
                  subLine.valid_to_year = endYear != subLine.valid_to_year ? startYear : subLine.valid_to_year

                  self.$nextTick(function () {
                    self.$refs.contractItem.setPrice(subLine, index)
                    self.$refs.contractItem.setHighLighter(subLine)
                  })
                })
              }

              line.valid_from_month = startYear != line.valid_from_year ? 1 : (line.valid_from_month ? (line.valid_from_changed ? line.valid_from_month : (line.id && !line.valid_from_changed ? line.valid_from_month: startMonth)) : startMonth)
              line.valid_from_year = startYear != line.valid_from_year ? startYear : line.valid_from_year

              line.valid_to_month = endYear != line.valid_to_year ? 12 : (line.valid_to_month ? (line.valid_to_changed ? line.valid_to_month : (line.id && !line.valid_to_changed ? line.valid_to_month: endMonth)) : endMonth)
              line.valid_to_year = endYear != line.valid_to_year ? startYear : line.valid_to_year
              self.$nextTick(function () {
                if(!self.saving) {
                  self.$refs.contractItem.setPrice(line, index)
                }

                self.$refs.contractItem.setHighLighter(line)
              })
            })
          }
        })
      }
    },
    getProductPrice(itm) {
      const self = this
      let price = null
      let addressKey = null
      if( self.addressIndex === 'all') {
        let addrFound = false
        self.item.addresses.forEach(function (address, key) {
          if (address.address_type === 'delivery' && !addrFound) {
            addressKey = key
            addrFound = true
          }
        })
      }
      const address = self.item.addresses[self.addressIndex === 'all' ? addressKey : self.addressIndex]
      if (itm.base_price && Object.keys(itm.base_price).length) {
        itm.base_price.forEach(function (p) {
          if (p.sales_line_price_category && Object.keys(p.sales_line_price_category).length) {
            if (p.sales_line_price_category.category_type === 'classification') {
              if (p.sales_line_price_category.price_category === address.customer_size) {
                price = p.price ? p.price: null
                return false
              }
            } else if (p.sales_line_price_category.category_type === 'fte') {
              if (p.price && address.fte) {
                price = p.price * address.fte
              }
              return false
            } else if (p.sales_line_price_category.category_type === 'fixed') {
              price = p.price ? p.price: null
              return false
            }
          }
        })
      }
      return price
    },
    addPreviousContract (contract) {
      this.item.previous_contract = contract.id
      this.item.previous = contract
      this.$refs.addPreviousContractModel.hide()
    },
    addItemsToAddresses(reset = true){
      const _self = this
      this.$nextTick(function (){
        if(_self.item.addresses) {
          _self.item.addresses.forEach(function (address, index) {
            if(address.address_type !== 'delivery') {
              return false
            }

            _self.setCustomerSize (address, index)
            if(reset || _self.$route.params.id === 'new') {
              _self.item.addresses[index].items = []
            }

            if (!address.items.length) {
              _self.addItemsToAddress (index, reset)
            }

            var sortOrder = 1
            if(address.items.length && _self.$route.params.id !== 'new') {
              address.items.forEach(function (item) {
                const itemPrice = _self.addItemPrice(item, index)
                const price = _self.$refs.contractItem.calculatePrice(item, index)

                item.item_price = itemPrice.price
                item.price = price.price
                item.price_changes = price.price_changes
                item.sort_order = sortOrder
                sortOrder++

                _self.$refs.contractItem.setHighLighter(item)
                if (item.children && Object.keys(item.children).length) {
                  item.children.sort((a, b) => a.sort_order - b.sort_order).forEach(function (subItem){
                    const subItemPrice = _self.addItemPrice(subItem, index)
                    const subPrice = _self.$refs.contractItem.calculatePrice(subItem, index)

                    subItem.item_price = subItemPrice.price
                    subItem.price = subPrice.price
                    subItem.price_changes = subPrice.price_changes
                    subItem.sort_order = sortOrder
                    sortOrder++

                    _self.$refs.contractItem.setHighLighter(subItem)
                    if (subItem.children && Object.keys(subItem.children).length) {
                      subItem.children.sort((a, b) => a.sort_order - b.sort_order).forEach(function (childItem) {
                        const childItemPrice = _self.addItemPrice(childItem, index)
                        const childPrice = _self.$refs.contractItem.calculatePrice(childItem, index)

                        childItem.item_price = childItemPrice.price
                        childItem.price = childPrice.price
                        childItem.price_changes = childPrice.price_changes
                        childItem.sort_order = sortOrder
                        sortOrder++
                      })
                    }
                  })
                }
              })
            }
          })
        }
      })
    },
    addItemsToAddress (index) {
      const _self = this
      if (!this.item.type) {
        return
      }

      if(_self.addItemsToAddressFlag && _self.addItemsToAddressFlagIndex === index) {
        return
      }

      _self.addItemsToAddressFlag = true
      _self.addItemsToAddressFlagIndex = index
      let url = '/api/sandoz/pv/items?c_type='+_self.item.type+'&c_start='+_self.item.contract_start+'&c_end='+_self.item.contract_expiration+'&c_lang='+_self.item.language+'&c_year='+_self.item.contract_year
      axios
        .get(url)
        .then((response) => {
          var sortOrder = 1
          response.data.forEach(function (item){
            const itemPrice = _self.addItemPrice(item, index)
            const price = _self.$refs.contractItem.calculatePrice(item, index)

            item.item_price = itemPrice.price
            item.price = price.price
            item.price_changes = price.price_changes
            item.sort_order = sortOrder
            sortOrder++

            _self.$refs.contractItem.setHighLighter(item)
            if (item.children && Object.keys(item.children).length) {
              item.children.sort((a, b) => a.sort_order - b.sort_order).forEach(function (subItem){
                const subItemPrice = _self.addItemPrice(subItem, index)
                const subPrice = _self.$refs.contractItem.calculatePrice(subItem, index)

                subItem.item_price = subItemPrice.price
                subItem.price = subPrice.price
                subItem.price_changes = subPrice.price_changes
                subItem.sort_order = sortOrder
                sortOrder++

                _self.$refs.contractItem.setHighLighter(subItem)
                if (subItem.children && Object.keys(subItem.children).length) {
                  subItem.children.sort((a, b) => a.sort_order - b.sort_order).forEach(function (childItem) {
                    const childItemPrice = _self.addItemPrice(childItem, index)
                    const childPrice = _self.$refs.contractItem.calculatePrice(childItem, index)

                    childItem.item_price = childItemPrice.price
                    childItem.price = childPrice.price
                    childItem.price_changes = childPrice.price_changes
                    childItem.sort_order = sortOrder
                    sortOrder++
                  })
                }
              })
            }

            _self.item.addresses[index].items.push(item)
          })

          _self.$nextTick(() => {
            _self.$refs.contractItem.setQuantityChildParent()
            _self.$refs.contractItem.setQuantityToChildSpecialLoad()
          })
          _self.addItemsToAddressFlag = false
          _self.addItemsToAddressFlagIndex = null
        })
    },
    addItemPrice(itm, index = -1){
      const self = this
      let itemPrice = null
      let priceChanges = {}
      const address = self.item.addresses[index === -1 ? self.addressIndex: index]
      if (itm.base_price && Object.keys(itm.base_price).length) {
        itm.base_price.forEach(function (p) {
          if (p.sales_line_price_category && Object.keys(p.sales_line_price_category).length) {
            if (p.sales_line_price_category.category_type === 'classification') {
              if (p.sales_line_price_category.price_category === address.customer_size) {
                itemPrice = p.price ? p.price: null
                priceChanges = p.price_changes
                return false
              }
            } else if (p.sales_line_price_category.category_type === 'fte') {
              if (p.price && address.fte) {
                if(p.fixed_independent_fte) {
                  itemPrice = p.price
                } else {
                  itemPrice = p.price * address.fte
                }
              }
              priceChanges = p.price_changes
              return false
            } else if (p.sales_line_price_category.category_type === 'fixed') {
              itemPrice = p.price ? p.price: null
              priceChanges = p.price_changes
              return false
            }
          } else if(p.price_changes) {
            priceChanges = p.price_changes
            return false
          }
        })
      }

      return {'price': itemPrice, 'price_changes': priceChanges?priceChanges:{}}
    },
    pdfContract() {
      this.saving = true
      this.$root.$loading.start()
      let delAddress = null
      this.item.addresses.forEach(function (address, key) {
        if (address.address_type === 'master' && delAddress === null) {
          delAddress = address
        }
      })

      let documentName = this.item.contract_no;
      if(this.item.contract_version !== null) {
        documentName += '-'+this.item.contract_version
      }else {
        documentName += '-1';
      }

      if(delAddress) {
        documentName += '-'+delAddress.company_name+' - '+delAddress.city
      }

      axios.post('/api/sandoz/generate-pdf2', {id:this.$route.params.id}, { responseType: 'arraybuffer' })
        .then((response) => {
          require('downloadjs')(
              response.data,
              documentName+'.pdf',
              'application/pdf'
          )
          this.$root.$loading.finish()
          this.saving = false
        }).catch((error) => {
          this.$root.$loading.finish()
          this.saving = false
          console.log(error)
        })
    },
    confirmWithUser() {
      const self = this
      var diffObject = diff(self.itemOld, self.item)
      delete diffObject['cap_exceeded']
      delete diffObject['sales_line']
      console.log("diffObject", diffObject)
      if((self.item.status === 'Draft' || self.item.status === 'Feedback') && (self.item.save_before_pdf_download || (diffObject && Object.keys(diffObject).length))) {
        self.$bvModal.msgBoxConfirm('Some changes are not saved!', {
            title: 'Save changes',
            size: 'md',
            buttonSize: 'sm',
            okVariant: 'primary',
            okTitle: 'Save & Continue',
            cancelTitle: 'Cancel',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
          })
        .then(value => {
          if(value) {
            self.downloadPDF = true
            self.item.is_pdf_download = true
            self.save()
          }
        })
        .catch(err => {
          console.log('error', err)
          // An error occurred
        })
      } else {
        self.pdfContract()
      }
    },
    showDuplicateContract () {
      const routeData = this.$router.resolve({ path: '/sandoz/ice_peak/contracts/' + this.showContract })
      window.open(routeData.href, '_blank')
    },
    updateEventCheckboxes(address, addrIndex) {
      if(address.items.length) {
        const self = this
        address.items.forEach(function (line, index) {
          if(line.type === 'service' && line.sandoz_academy_event && !self.$refs.contractItem.isReadonly(line, 'yearly')) {
            line.delivery.yearly.quantity = address.eventHeaderCheckbox ? 1 : 0

            self.$refs.contractItem.setQuantityToChild(line, 'q1', addrIndex)
            self.$refs.contractItem.setPrice(line, addrIndex, 'yearly')

            if (line.children && Object.keys(line.children).length) {
              line.children.forEach(function (subLine, subLineIndex) {
                if(subLine.type === 'service' && subLine.sandoz_academy_event && !self.$refs.contractItem.isReadonly(subLine, 'yearly')) {

                  subLine.delivery.yearly.quantity = address.eventHeaderCheckbox ? 1 : 0
                  self.$refs.contractItem.setQuantityToParent(line, subLine, 'yearly', addrIndex)
                  self.$refs.contractItem.setQuantityToChild(subLine, 'yearly', subLineIndex)
                  self.$refs.contractItem.setBoxQuantity(line, 'yearly', subLine.box_or_gadget, addrIndex)

                  if (subLine.children && Object.keys(subLine.children).length) {
                    subLine.children.forEach(function (childLine, childLineIndex) {
                      if(childLine.type === 'service' && childLine.sandoz_academy_event && !self.$refs.contractItem.isReadonly(childLine, 'yearly')) {

                        childLine.delivery.yearly.quantity = address.eventHeaderCheckbox ? 1 : 0
                        self.$refs.contractItem.setQuantityToParent(subLine, childLine, 'yearly', addrIndex)
                        self.$refs.contractItem.setBoxQuantity(line, 'yearly', childLine.box_or_gadget, addrIndex)
                      }
                    })
                  }
                }
              })
            }
          }
        })
      }
    },
    checkLineChildren(line) {

      if(line.children && Object.keys(line.children).length)
      {
        return true
      }
      return false
    },
    checkIndeterminantCheckbox() {
      if(this.item.addresses) {
        const self = this

        var determError = false;
        self.determErrorID = []
        self.item.addresses.forEach(function (address, index) {
          if(address.address_type === 'delivery') {
            address.items.forEach(function (line, lineIndex) {
              if(line.type === 'marketing_activity' && line.contract_line_exist_attribute === 'indeterminate' && (line.exists_attribute_required || line.exist_value !== null) && (line.delivery && line.delivery['yearly'].quantity !== null || line.delivery['q1'].quantity !== null || line.delivery['q2'].quantity !== null || line.delivery['q3'].quantity !== null || line.delivery['q4'].quantity !== null)) {
                determError = true;
                self.determErrorID.push(address.id+'-'+line.product.id)
              }

              if(line.children && Object.keys(line.children).length) {
                line.children.forEach(function (subLine, subLineIndex) {

                  if(subLine.type === 'marketing_activity' && subLine.contract_line_exist_attribute === 'indeterminate' && (subLine.exists_attribute_required || subLine.exist_value !== null) && (subLine.delivery && subLine.delivery['yearly'].quantity !== null || subLine.delivery['q1'].quantity !== null || subLine.delivery['q2'].quantity !== null || subLine.delivery['q3'].quantity !== null || subLine.delivery['q4'].quantity !== null)) {
                    determError = true;
                    self.determErrorID.push(address.id+'-'+subLine.product.id)
                  }

                  if(subLine.children && Object.keys(subLine.children).length) {
                    subLine.children.forEach(function (childLine, childLineIndex) {
                      if(childLine.type === 'marketing_activity' && childLine.contract_line_exist_attribute === 'indeterminate' && (childLine.exists_attribute_required || childLine.exist_value !== null) && (childLine.delivery && childLine.delivery['yearly'].quantity !== null || childLine.delivery['q1'].quantity !== null || childLine.delivery['q2'].quantity !== null || childLine.delivery['q3'].quantity !== null || childLine.delivery['q4'].quantity !== null)) {
                        determError = true;
                        self.determErrorID.push(address.id+'-'+childLine.product.id)
                      }
                    })
                  }
                })
              }
            })
          }
        })

        return determError
      }
    },
    setTitleItems () {
      if(this.item.language === 'DE') {
        this.titleItems = [
          { value: null, text: 'Partnertitel auswählen' },
          { value: 'Inhaber', text: 'Inhaber'},
          { value: 'Inhaberin', text: 'Inhaberin' },
          { value: 'Dr. med.', text: 'Dr. med.'},
          { value: 'Geschäftsführer', text: 'Geschäftsführer'},
          { value: 'Geschäftsführerin', text: 'Geschäftsführerin'},
          { value: 'FMH Allgemeine Innere Medizin', text: 'FMH Allgemeine Innere Medizin'}
        ]
      } else if(this.item.language === 'FR') {
        this.titleItems = [
          { value: null, text: 'Sélectionnez le titre du partenaire' },
          { value: 'Propriétaire', text: 'Propriétaire'},
          { value: 'Pharmacienne responsable', text: 'Pharmacienne responsable' },
          { value: 'Pharmacien responsable', text: 'Pharmacien responsable'},
          { value: 'Pharmacienne', text: 'Pharmacienne'},
          { value: 'Pharmacien', text: 'Pharmacien'},
          { value: 'Dr. med.', text: 'Dr. med.'}
        ]

      } else if(this.item.language === 'IT') {
        this.titleItems = [
          { value: null, text: 'Seleziona il titolo del partner' },
          { value: 'Gerente', text: 'Gerente'},
          { value: 'Proprietario', text: 'Proprietario' },
          { value: 'Proprietaria', text: 'Proprietaria'},
          { value: 'Dr. med.', text: 'Dr. med.'}
        ]
      }
    },
    setTitle (i) {
      this.item['contract_partner_'+i+'_title'] = this.item['contract_partner_'+i+'_title_dropdown']
    },
    changeContractDuration() {
      const startDate = moment(this.item.contract_start)
      const startYear = startDate.format('YYYY')
      if(startYear !== this.item.contract_year) {
        this.item.contract_start = this.item.contract_year + '-01-01'
        this.item.contract_expiration = this.item.contract_year + '-12-31'
      }
    },
    openKuko(kukoID) {
      if(kukoID !== '') {
        this.$router.push({ name:'sandoz.kuko.detail', params: {id:kukoID}})
      }
    },
    createKuko() {
      this.$nextTick(async function () {
        const contract = await axios.post(`/api/sandoz/ice-peak/contracts/search-addresses`, {
          q: this.item.customer_external_id
        }).then(response => {
          if ('0' in response.data.data) {
            return response.data.data[0]
          }
          return null
        })

        const route = this.$router.resolve({
          name: 'sandoz.kuko.detail', params: { id: 'new' }, query: {
            type: this.item.type,
            year: this.item.contract_year,
            external_id: this.item.customer_external_id,
            sap_id: contract ? contract.org_sap_id : null,
            sub_type: contract ? contract.org_sub_type : null,
            primary: contract ? contract.parent_full_name : null,
            company: contract ? contract.org_full_name : null,
            street: contract ? contract.org_street : null,
            city: contract ? contract.org_zip_code + " " + contract.org_city : null
          }
        })
        window.open(route.href)
      })
    },
    formatDescription(value) {
      if(value) {
        return this.$options.filters.formatInteger(value);
      }
      return null
    },
    marketingActivityTotalAvailable() {
      this.item.marketing_activities_maximum = Number.isNaN(this.item.marketing_activities_maximum) || isNaN(parseFloat(this.item.marketing_activities_maximum)) ? 0 : parseFloat(this.item.marketing_activities_maximum)
      this.item.marketing_activities = Number.isNaN(this.item.marketing_activities) || isNaN(parseFloat(this.item.marketing_activities)) ? 0 : parseFloat(Math.round(this.item.marketing_activities))
      return this.item.marketing_activities_maximum - this.item.marketing_activities
    },
    calculatePriceBasedonDuration(val) {
      // if(val !== null && val !== 0 && val !== 0.00 && this.item && this.$route.params.id === 'new') {
      //   var contractStart = this.item.contract_start
      //   var contractExpiration = this.item.contract_expiration
      //   contractStart = contractStart === null ? 12 : parseInt(moment(contractStart).format('MM'))
      //   contractExpiration = contractExpiration === null ? 12 : parseInt(moment(contractExpiration).format('MM'))
      //   var durationVal = (val / 12) * ((contractExpiration - contractStart) + 1)
      //   return parseInt(durationVal)
      // }
      return val
    },
    checkDifferenceAndGetPercDeviation(val) {
      if(this.item.sales_line) {
        if(val > 0 && val <= 10000) {
          return this.item.sales_line.deviation_range_1
        } else if(val > 10000 && val <= 20000) {
          return this.item.sales_line.deviation_range_2
        } else if(val > 20000) {
          return this.item.sales_line.deviation_range_3
        }
      }
      return null
    }
  }
}
</script>

<style scoped>
.invest-accordion svg:focus {
  outline: none;
}

td.exist_error {
  border: 1px solid red;
}

.pdfFiles {
  padding-left: 0;
  font-size: 120%;
  margin-top: 10px;
  text-transform: uppercase;
  font-weight: bold;
  border-bottom: none !important;
}

.pdfFiles .show-deleted-checkbox {
  font-size: 90% !important;
  text-transform: lowercase;
  font-weight: normal;
}

.bg-disable {
  background: lightgrey;
}
</style>


